import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <div className="max-w-[820px] mx-auto px-4 md:px-8 pt-10 md:pt-16 pb-16">
      <div className="flex items-center gap-2 text-sm text-text-muted mb-4">
        <Link to="/" className="text-text-secondary hover:text-accent transition-colors">Home</Link>
        <span>/</span>
        <span>Terms</span>
      </div>

      <h1 className="font-display text-2xl md:text-[2.5rem] font-bold tracking-tight mb-2">Terms of use</h1>
      <p className="text-text-muted text-sm mb-8">Last updated: 20 July 2026</p>

      <div className="article-body">
        <p>
          These terms govern your use of marinelink.co.nz ("the site"), operated by MarineLink Co NZ
          ("MarineLink", "we", "us"). By using the site you accept these terms. If you don't, please don't
          use the site.
        </p>

        <h2>What MarineLink is</h2>

        <p>
          MarineLink is a directory of New Zealand marine businesses, plus editorial content about the
          marine industry. Listing information is provided by the businesses themselves and from publicly
          available sources. We work hard to keep it accurate - including regular quality reviews - but we
          can't guarantee every detail is current. Always confirm pricing, availability, qualifications and
          survey status directly with the business.
        </p>

        <h2>Using the directory</h2>

        <p>
          You may browse and share links to the site freely. You may not scrape, bulk-download or republish
          the directory's contents, or use listing contact details for unsolicited marketing. The site's
          design, branding and editorial content are our intellectual property.
        </p>

        <h2>Business listings</h2>

        <p>
          If you list a business, you're responsible for the accuracy of what you submit and for having the
          right to publish it. You confirm the business is real, operating, and appropriately qualified for
          the services it advertises. We may edit, decline or remove listings that are inaccurate, misleading,
          outdated or outside the marine industry, and we'll tell you if we do.
        </p>

        <p>
          Paid listings are billed through Stripe. Prices are in New Zealand dollars and include GST where
          applicable. Renewal reminders are sent before a listing expires. We don't provide refunds for
          change of mind part-way through a paid term, but if we've made an error we'll put it right.
        </p>

        <h2>Editorial content</h2>

        <p>
          Marine News articles are our editorial view of industry happenings, written in good faith from
          publicly reported information. They aren't financial, legal or safety advice, and linking to or
          mentioning a business isn't an endorsement unless we say it is.
        </p>

        <h2>Liability</h2>

        <p>
          The site is provided "as is". To the extent the law allows, we're not liable for loss arising from
          reliance on listing information, from dealings between you and a listed business, or from site
          downtime. Nothing in these terms limits your rights under the Consumer Guarantees Act 1993 or the
          Fair Trading Act 1986.
        </p>

        <h2>Changes</h2>

        <p>
          We may update these terms from time to time; the date above shows the current version. Continued
          use after a change means you accept the updated terms. These terms are governed by New Zealand law.
        </p>

        <h2>Contact</h2>

        <p>
          Questions about these terms:{' '}
          <a href="mailto:info@marinelink.co.nz" className="text-accent hover:underline">info@marinelink.co.nz</a>.
        </p>
      </div>
    </div>
  );
}
